import { css } from '@emotion/core';
import { globalTokens, rgba } from '@domain-group/fe-brary';
import { popupZIndex } from '../allhomes-listing-map-search.style';
var _ref = {
  name: "1sxwmux",
  styles: "top:-350px;"
};
var _ref2 = {
  name: "1tv3xfy",
  styles: "top:-333px;"
};
var _ref3 = {
  name: "j2zt95",
  styles: "top:-357px;"
};
var _ref4 = {
  name: "1qeyndz",
  styles: "top:-410px;"
};
var _ref5 = {
  name: "j8w2d",
  styles: "top:-435px;"
};
export var popup = function popup() {
  var _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasInspection1 = _ref0.hasInspection1,
    hasInspection2 = _ref0.hasInspection2,
    isMultiple2 = _ref0.isMultiple2,
    isMultiple3Plus = _ref0.isMultiple3Plus;
  return /*#__PURE__*/css("position:absolute;border-radius:3px;background-color:", globalTokens.colors.white, ";box-shadow:0 1px 8px 0 ", rgba(globalTokens.colors.black, 0.15), ";z-index:", popupZIndex, ";top:-328px;left:-200px;width:400px;height:auto;overflow:hidden;&::after,&::before{top:100%;left:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&::after{border-color:", rgba(globalTokens.colors.black, 0), ";border-top-color:", globalTokens.colors.white, ";border-width:15px;margin-left:-15px;}&::before{border-color:rgba(", globalTokens.colors.black, ",0);border-top-color:", globalTokens.colors.white, ";border-width:16px;margin-left:-16px;}", hasInspection1 && _ref, " ", isMultiple2 && /*#__PURE__*/css("top:-310px;", hasInspection1 && _ref2, " ", hasInspection2 && _ref3), " ", isMultiple3Plus && /*#__PURE__*/css("top:-388px;", hasInspection1 && _ref4, " ", hasInspection2 && _ref5));
};

// TODO: styles inner component
var _ref6 = {
  name: "1c0gh0g",
  styles: "height:312px;"
};
var _ref7 = {
  name: "1dfbzua",
  styles: "height:334px;"
};
var _ref8 = {
  name: "13ze708",
  styles: "height:391px;"
};
var _ref9 = {
  name: "14lheoz",
  styles: "height:414px;"
};
export var popupListings = function popupListings() {
  var _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasInspection1 = _ref1.hasInspection1,
    hasInspection2 = _ref1.hasInspection2,
    isMultiple2 = _ref1.isMultiple2,
    isMultiple3Plus = _ref1.isMultiple3Plus;
  return /*#__PURE__*/css("margin:0 auto;width:auto;overflow:visible;text-align:left;", isMultiple2 && /*#__PURE__*/css("height:288px;", hasInspection1 && _ref6, " ", hasInspection2 && _ref7), " ", isMultiple3Plus && /*#__PURE__*/css("overflow-y:auto;height:365px;.allhomes-watchlist-button__popup{position:fixed;}.allhomes-watchlist-button__popup::before,.allhomes-watchlist-button__popup::after{display:none;}", hasInspection1 && _ref8, " ", hasInspection2 && _ref9));
};